import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { TESTIMONIALS } from '../lib/constants';
// Short testimonials matching the product avatar.
export function TestimonialsSection() {
  return <section className="px-5 py-8" data-id="element-162">
      <div className="mx-auto max-w-md" data-id="element-163">
        <h2 className="text-center font-[Montserrat] text-xl font-extrabold text-white" data-id="element-164">
          Historias de quienes ya navegan con su PER
        </h2>

        <div className="mt-6 space-y-3" data-id="element-165">
          {TESTIMONIALS.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.35,
          delay: i * 0.04
        }} className="relative rounded-xl border border-[#c8a24a]/25 bg-[#0b2545]/70 p-4" data-id="element-166">
              <QuoteIcon className="absolute right-3 top-3 h-6 w-6 text-[#c8a24a]/25" aria-hidden="true" data-id="element-167" />
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-168">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-3.5 w-3.5 fill-[#e6c168] text-[#e6c168]" aria-hidden="true" data-id="element-169" />)}
              </div>
              <blockquote className="mt-2 text-sm leading-relaxed text-blue-50" data-id="element-170">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-2 text-xs font-bold text-[#e6c168]" data-id="element-171">
                {t.name}
                <span className="font-medium text-blue-200" data-id="element-172">
                  {' '}
                  · {t.age} años · {t.city}
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}